export const FEATURE_QUERY_PARAM = 'feature'
export const FEATURE_HEADER = 'x-feature-env'
export const FEATURE_STORAGE_KEY = 'feature-env'
